import React from "react";
import { COMPANY_NAME } from "../config/site";

const Footer = () => (
	<footer className="border-t border-line bg-white py-6">
		<div className="shell flex flex-col items-start justify-between gap-2 text-[10px] uppercase tracking-[.08em] text-muted sm:flex-row sm:items-center">
			<span>{ COMPANY_NAME }</span>
			<span>Uruguay · { new Date().getFullYear() }</span>
		</div>
	</footer>
);

export default Footer;
